import { Language } from '@shared/types'
import { ReactNode } from 'react'
import { createIntl, IntlShape } from 'react-intl'

import commonFiMessages from '../../src/l10n/fi.json'
import { Messages } from '../types'

const strong = (chunks: ReactNode) => <strong>{chunks}</strong>
// react-intl types fail to accept valid configuration, thus any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const br: any = <br />
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const non_breaking_hyphen: any = '‑'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const soft_hyphen: any = '\u00AD'
const ul = (text: ReactNode) => <ul>{text}</ul>
const li = (text: ReactNode) => <li>{text}</li>
const p = (text: ReactNode) => <p>{text}</p>

export const richTextConfig = {
  strong,
  br,
  non_breaking_hyphen,
  soft_hyphen,
  ul,
  li,
  p,
}

export const getFiIntl = (messages: Messages): IntlShape => {
  return createIntl({
    locale: Language.Fi,
    messages: { ...commonFiMessages, ...messages },
    defaultRichTextElements: richTextConfig,
  })
}
